export const defaultLabels = ['new', 'vip', 'normal', 'dormant'];
